import languages from "google-tts-languages";

const baseSelectContent = {
  type: "select",
  inputType: "submit",
  label: "",
  data: {
    languages: languages,
    value: "",
    type: "",
    isUpdated: false,
  },
  translation: {
    input: "",
    flag: false,
    isUpdated: false,
  },
};

const baseImageContent = {
  type: "image",
  inputType: "",
  label: "",
  data: {
    id: "",
    name: "",
    iconUrl: "",
    value: "",
    adminId: "",
    file: {},
    isUpdated: false,
  },
  translation: {
    input: "",
    flag: false,
    isUpdated: false,
  },
};

const createSelectEntry = (title: string, label: string, type: string) => ({
  title,
  content: {
    ...baseSelectContent,
    label,
    data: {
      ...baseSelectContent.data,
      type,
    },
  },
  isRequired: false,
  readonly: false,
  isButton: false,
});

const createImageEntry = (title: string, isButton: boolean) => ({
  title,
  content: baseImageContent,
  isRequired: false,
  readonly: false,
  isButton,
});

const languagesResources = [
  createSelectEntry("Add Language", "Add Language", "add_lang"),
  createImageEntry("Language Icon", true),
  createSelectEntry("Select Language", "Select Language", "select_lang"),
];

export { languagesResources };
